import { Button, Input, List, Modal, Space } from "antd"
import { useEffect, useState } from "react"
import { QboVendor } from "./vendorsModel"
import { useQboVendorsListQuery } from "./vendorsQueries"
import { blue } from "@ant-design/colors"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faCheck, faLink } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  isOpen: boolean
  onCancel: () => void
  initialFilter: string
  onLink: (qboVendor: QboVendor, updateInfo: boolean) => void
}

const LinkQuickBooksVendorModal = ({
  isOpen,
  onCancel,
  initialFilter,
  onLink,
}: Props) => {
  const [searchFilter, setSearchFilter] = useState(initialFilter)
  const { data: qboVendorsListData, refetch } = useQboVendorsListQuery(false)
  const filteredQboVendors = (qboVendorsListData ?? []).filter((vendor) => vendor.displayName.toLowerCase().includes(searchFilter.toLowerCase()))
  const [selectedVendor, setSelectedVendor] = useState<QboVendor | undefined>()

  const handleSelect = (qboVendor: QboVendor) => {
    setSelectedVendor(qboVendor)
  }

  useEffect(() => {
    if (isOpen) {
      setSearchFilter(initialFilter || '');
      refetch()
    }
  }, [isOpen, initialFilter]);

  const linkAndUpdateInfo = () => {
    onLink(selectedVendor!, true)
  }

  const linkVendor = () => {
    onLink(selectedVendor!, false)
  }

  const handleCancel = () => {
    onCancel()
  }

  return (
    <Modal
      title={
        <Space>
          <FontAwesomeIcon icon={faLink} /> Link to QuickBooks Vendor
        </Space>
      }
      open={isOpen}
      onCancel={handleCancel}
      footer={
        <>
          <Button key="back" onClick={onCancel} icon={<FontAwesomeIcon icon={faArrowLeft} />}>
            Close
          </Button>
          <Button
            key="link"
            type="default"
            onClick={linkVendor}
            disabled={selectedVendor === undefined}
            icon={<FontAwesomeIcon icon={faCheck} />}
          >
            Link
          </Button>
          <Button
            key="submit"
            type="primary"
            onClick={linkAndUpdateInfo}
            disabled={selectedVendor === undefined}
            icon={<FontAwesomeIcon icon={faCheck} />}
          >
            Link & Update Info
          </Button>
        </>
      }
    >
      <Input
        value={searchFilter}
        style={{ marginBottom: 16 }}
        placeholder="Search QuickBooks vendors..."
        onChange={(e) => setSearchFilter(e.target.value)}
      />

      <VendorList
        vendors={filteredQboVendors}
        selectedVendor={selectedVendor?.id ?? ''}
        onLink={handleSelect}
      />
    </Modal>
  )
}

export default LinkQuickBooksVendorModal

const VendorList = ({
  vendors,
  selectedVendor,
  onLink,
}: {
  vendors: QboVendor[]
  selectedVendor: string
  onLink: (vendor: QboVendor) => void
}) => (
  <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
    <List
      itemLayout="horizontal"
      dataSource={vendors}
      renderItem={(item) => (
        <List.Item
          onClick={() => onLink(item)}
          style={{
            cursor: "pointer",
            background: selectedVendor.includes(item.id.toString()) ? blue[1] : "transparent",
            padding: 16,
          }}
        >
          {item.displayName}
        </List.Item>
      )}
    />
  </div>
);